<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light shadow fixed-top">
        <div class="container">
            <router-link to="/" class="navbar-brand">
                <img src="../assets/logo_small.png" class="img-fluid" alt="MySwitchPro" />
            </router-link>
            <ul class="navbar-nav"  v-if="$store.getters['auth/isGuest'] && $route.name && !$route.name.startsWith('Register') && !$route.name.startsWith('Setup')">
                <li class="nav-item">
                    <button class="btn btn-block btn-outline-info login-button" @click="$refs.loginModal.show()">Login</button>
                </li>
            </ul>

            <ul class="navbar-nav ml-0" v-if="$store.getters['auth/isUser']">
                <li class="nav-item p-1 border-right d-none d-lg-inline" :class="{active: $route.name === 'Dashboard'}"
                    v-if="$route.name !== 'SetupDeal'">
                    <router-link :to="{name: 'Dashboard'}" class="nav-link">Home</router-link>
                </li>
                <li class="nav-item p-1 border-right d-none d-lg-inline" :class="{active: $route.name === 'ProfileRewards'}"
                    v-if="$route.name !== 'SetupDeal'">
                    <router-link class="nav-link" :to="{name: 'ProfileRewards'}">
                        My Rewards: <span class="text-success font-weight-bold">£{{$store.getters['auth/balance'] || 0}}</span>
                    </router-link>
                </li>
                <li class="nav-item dropdown" :class="{active: $route.name === 'ProfileSettings'}" >
                    <profile-drop-down ref="profileDropdown"/>
                </li>
            </ul>
        </div>
        <login-modal ref="loginModal" v-if="$store.getters['auth/isGuest']" />
    </nav>
</template>

<script>
import LoginModal from "./auth/LoginModal";
import ProfileDropDown from "./auth/ProfileDropDown";

export default {
        components: {ProfileDropDown, LoginModal},
        name: "Navigation"
    }
</script>
<style scoped lang="scss">
    @import "../sass/base";
    .navbar {
        min-height: 69px;
    }
    .navbar-brand {
        @include media-breakpoint-down(lg){
            margin-right: 0;
        }
        > img {
            height: 45px;
            @include media-breakpoint-down(lg){
                height: 30px;
            }
        }
    }
    .login-button {
        width: 120px;
    }

    .nav-item {
        &.active {
            background-color: $gray-200;
            border-radius: $border-radius;
        }
    }


</style>
